import React, { useCallback, useMemo } from "react";
import clsx from "clsx";
import { PROSPECT_ROUTER, CUSTOMER_ROUTER } from "@icoach/nonMember/staticData";
import MoreLabel, { NON_MEMBER_MORE_LABEL_MAP } from "@icoach/nonMember/components/MoreLabel";
import useNonMember from "@icoach/nonMember/components/useNonMember";
import IconGroupHeader from "@icoach/nonMember/components/IconGroupHeader";
import Tablenization from "@icoach/components/Tablenization";
import { FormControlLabel, Checkbox, Box } from "@curves/ui-base";
import useGroupCheckbox from "@util/hook/useGroupCheckbox";
import usePrivacyToggle, { securityMaskFilterTypeMap } from "@util/hook/usePrivacyToggle";
import { getCustomerRowsLabel, getProspectRowsLabel } from "@icoach/nonMember/tableColumnsConfig";

const TemporariesInfoTable = props => {
	const { setBookmarkNum } = useNonMember();
	const { sourceData = {}, type: propsType, refresh } = props;
	let { pageIndex: page = 1, totalPage: count = 1, list: rowsData = [] } = sourceData;
	const [handleCheckAllChange, handleCheckedChange, selectedAllRef, selectedOptRef, indeterminateRef] = useGroupCheckbox(rowsData);
	const { isRevealed, toggle, renderPrivacyIcon } = usePrivacyToggle();

	const handlePageChange = (e, num) => {
		setBookmarkNum(num);
	};

	const handleToggleRevealed = useCallback(
		() => {
			const apiParams = {
				filterType: securityMaskFilterTypeMap.ClubCustomerTemporary,
				totalCount: rowsData.length,
			};
			toggle(apiParams);
		},
		// eslint-disable-next-line
		[rowsData.length, toggle]
	);

	const tableTitleLabel = useMemo(
		() => {
			const getMoreLabel = () => ({
				cellKey: "more",
				headerLabel: "",
				align: "right",
				isIcon: true,
				formatCell: (cellValue, rowData) => {
					return <MoreLabel moreActionArray={[NON_MEMBER_MORE_LABEL_MAP.REMOVETEMP]} sourceData={rowData} {...(rowData || {})} />;
				},
			});
			const overviewLabelMap = {
				[PROSPECT_ROUTER]: getProspectRowsLabel(),
				[CUSTOMER_ROUTER]: getCustomerRowsLabel(),
			};
			return [...overviewLabelMap[propsType], getMoreLabel()];
		},
		// eslint-disable-next-line
		[propsType]
	);

	return (
		<Box className="customer-table">
			<Box className="customer-table-action">
				<Box className={clsx("customer-table-action-icon", rowsData.length === 0 && "visibility-hidden")}>
					<FormControlLabel
						value="all"
						label="全選"
						control={<Checkbox color="primary" indeterminateRef={indeterminateRef} inputRef={el => (selectedAllRef.current = el)} onChange={handleCheckAllChange} />}
					/>
					<IconGroupHeader viewIconArray={["removetemp"]} selectedRef={selectedOptRef} rowsData={rowsData} refresh={refresh.current} />
					{renderPrivacyIcon(handleToggleRevealed, "has-divider")}
				</Box>
			</Box>
			<Box>
				<Tablenization isPagination page={page} count={count} onChange={handlePageChange}>
					<Tablenization.TableRowHeader headerRow={tableTitleLabel} />
					<Tablenization.TableRowBody headerRow={tableTitleLabel} rowsData={rowsData} chkRef={selectedOptRef} checkedOnChange={handleCheckedChange} isRevealed={isRevealed} />
				</Tablenization>
			</Box>
		</Box>
	);
};

export default TemporariesInfoTable;
